import { createFileRoute, redirect } from '@tanstack/react-router';

// Root URL lands on the application picker (`/apps`). From there the user
// picks the app they want — Tasks, Health, etc. — rather than us guessing.
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/apps' });
  },
});
